import { combineReducers } from 'redux';

import revenueSummaryReport from './report/reducer';

export default combineReducers({
  revenueSummaryReport,
});



// WEBPACK FOOTER //
// ./src/pages/revenuesummaryreport/state/reducer.js